import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import { lazyPage, type LazyPage } from "./lazyPage";

// Home ships in the main bundle (it is the landing page and the LCP); every other
// page is its own chunk so the homepage doesn't download and parse the FAQ,
// policies, impact report and blog data before it becomes interactive.
const About = lazyPage(() => import("./pages/About"));
const Availability = lazyPage(() => import("./pages/Availability"));
const TripPricing = lazyPage(() => import("./pages/TripPricing"));
const Faq = lazyPage(() => import("./pages/Faq"));
const YouthBuilders = lazyPage(() => import("./pages/YouthBuilders"));
const ParentBuilders = lazyPage(() => import("./pages/ParentBuilders"));
const TripLeaders = lazyPage(() => import("./pages/TripLeaders"));
const ParentsAtHome = lazyPage(() => import("./pages/ParentsAtHome"));
const PayingForYourTrip = lazyPage(() => import("./pages/PayingForYourTrip"));
const ImpactReport = lazyPage(() => import("./pages/ImpactReport"));
const Policies = lazyPage(() => import("./pages/Policies"));
const Blog = lazyPage(() => import("./pages/Blog"));
const Registration = lazyPage(() => import("./pages/Registration"));
const Accessibility = lazyPage(() => import("./pages/Accessibility"));
const BlogPost = lazyPage(() => import("./pages/BlogPost"));
// Carries the blog index for its "did you mean" suggestions; keep it off the homepage.
const NotFound = lazyPage(() => import("./pages/NotFound"));

const PAGES: Record<string, LazyPage> = {
  "/about": About,
  "/availability": Availability,
  "/trip-pricing": TripPricing,
  "/faq": Faq,
  "/youth-builders": YouthBuilders,
  "/parent-builders": ParentBuilders,
  "/trip-leaders": TripLeaders,
  "/parents-at-home": ParentsAtHome,
  "/paying-for-your-trip": PayingForYourTrip,
  "/2025-impact-report": ImpactReport,
  "/policies": Policies,
  "/blog": Blog,
  "/registration": Registration,
  "/accessibility": Accessibility,
};

/** Loads the chunk for `pathname` so the first render can hydrate without suspending. */
export const preloadRoute = (pathname: string) => {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/") return Promise.resolve();
  const page = PAGES[path] ?? (/^\/[^/]+$/.test(path) ? BlogPost : NotFound);
  return page.preload();
};

/** Prerender only: resolve every chunk so renderToString emits full pages. */
export const preloadAllPages = () =>
  Promise.all([...Object.values(PAGES), BlogPost, NotFound].map((p) => p.preload()));

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        {Object.entries(PAGES).map(([path, Page]) => (
          <Route key={path} path={path} element={<Page />} />
        ))}
        {/* Blog posts keep their original WordPress slugs at the root
            (e.g. /packing-tips). BlogPost 404s for unknown slugs. */}
        <Route path="/:slug" element={<BlogPost />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
